'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import Icon from '@/components/Icon/Icon';
import { Text } from '@/components/Typography';
import { defaultNS, useTranslation } from '@/lib/i18n';

import { IndividualSidebar } from '../../-components/IndividualSidebar';

import { MyClockingSummaryCard } from './-components/MyClockingSummaryCard';
import { MyPaySlipSummaryCard } from './-components/MyPaySlipSummaryCard';

export const Route = createFileRoute('/_individual/individual/portal/lookup/')({
  component: LookupPage,
});

function LookupPage() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'individualPages.home.lookup',
  });

  return (
    <div className="flex h-full min-h-0 w-full overflow-hidden">
      <IndividualSidebar
        mode="portal"
        open={sidebarOpen}
        onToggle={() => setSidebarOpen((v) => !v)}
      />
      <main className="min-w-0 flex-1 overflow-auto bg-neutral-bottom-fill">
        <div className="min-h-full bg-blue-50/30">
          <div className="mx-auto max-w-[1280px] px-[100px] py-10">
            <div className="mx-auto flex w-full max-w-[800px] flex-col gap-6">
              <div className="flex items-center gap-2">
                <div className="flex h-11 w-11 items-center justify-center rounded-sm bg-primary-muted-fill">
                  <Icon
                    iconName="Eye"
                    className="h-7 w-7 text-primary-on-muted-fill"
                    inheritColor
                  />
                </div>
                <Text as="h2" variant="h2">
                  {t('title')}
                </Text>
              </div>
              <MyClockingSummaryCard />
              <MyPaySlipSummaryCard />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
